import { React, useState, useEffect } from 'react';
import EmailProvider from '../../../components/Settings/EmailProvider/EmailProvider';
import SideBar from '../../../components/SideBar/SideBar';
import CollapseIcon from '../../../assets/images/sidebar_collapse_arrow.svg';
import BannerNotification from 'components/BannerNotification/BannerNotification';

function EmailProviderContainer({ location, history }) {

    useEffect(() => {
        if(location.search){
            let query = location.search.split('=')
            if(query[0] === '?error' || query[0] === 'access_denied'){
                history.push('/settings/email-provider')
            }
        }

        //eslint-disable-next-line
    }, [])

    const [isActive, setActive] = useState("false");

    const handleToggle = () => {
        setActive(!isActive);
    };

    return (
        <div className='sidebar_main_wrapper'>
            <div className={isActive ? "sidebar" : "sidebar sidebar-collapse"}>
                <button onClick={handleToggle} className={isActive ? 'collapse-icon' : 'collapse-icon rotate-icon'}>
                    <img src={CollapseIcon} alt="icon" />
                </button>
                <SideBar />
            </div>
            <div className={isActive ? "right-container" : "right-container right-container-collapse"}>
                <BannerNotification />
                <div className='right-inner-container'>
                    <EmailProvider />
                </div>
            </div>
        </div>
    )
}

export default EmailProviderContainer;
